export class LogoNames {
  static readonly PATH = ['assets/sprites/logos.svg#'];
  static readonly NIB = 'nibau';
  static readonly SV = 'sv';

  static readonly LOGOS = {
    nib: `${LogoNames.PATH}${LogoNames.NIB}`,
    supervalu: `${LogoNames.PATH}${LogoNames.SV}`,
  };
}
